<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <div class="row">
            <div class="col-12 mb-4">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">{{ isEdicao ? 'Editar localização' : 'Nova localização' }}</h1>
                        <p class="welcome-message">
                            <button mat-icon-button (click)="voltar()"><mat-icon>arrow_back</mat-icon></button>
                            Preencha os dados abaixo para {{ isEdicao ? 'editar' : 'cadastrar' }} a localização de
                            estoque.
                        </p>
                    </div>
                </div>
            </div>
            @if(isLoading) {
            <div class="col-12"><app-loading-box height="200"></app-loading-box></div>
            } @else {
            <div class="col-12">
                <form [formGroup]="form">
                    <div class="row">
                        <div class="col-md-4 col-12">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Código</mat-label>
                                <input matInput formControlName="codigo" placeholder="Ex.: PADRAO, GALPAO-A" required>
                                @if (form.get('codigo')?.hasError('required')) {
                                <mat-error>O código é <strong>obrigatório</strong></mat-error>
                                }
                            </mat-form-field>
                        </div>                        
                        <div class="col-md-2 col-12 d-flex align-items-center toggle-field">
                            <span [matTooltip]="isPadrao ? 'A localização padrão deve permanecer ativa.' : ''">
                                <mat-slide-toggle class="app-toggle-compact" formControlName="isAtivo">Ativa</mat-slide-toggle>
                            </span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 col-12">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Nome</mat-label>
                                <input matInput formControlName="nome" placeholder="Digite o nome da localização"
                                    required>
                                @if (form.get('nome')?.hasError('required')) {
                                <mat-error>O nome é <strong>obrigatório</strong></mat-error>
                                }
                            </mat-form-field>
                        </div>
                    </div>
                </form>
            </div>
            }
        </div>
    </div>
</div>
<app-footer-action [isLoadingSalvar]="isSaving" [isSalvarDisabled]="isLoading" (cancelar)="voltar()"
    (salvar)="salvar()"></app-footer-action>
